import { Cell, Pie, PieChart } from 'recharts';
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
  type ChartConfig,
} from '@/components/ui/chart';
import type { CategorySlice } from '@/types/analytics';

interface CategoryDistributionChartProps {
  data: CategorySlice[];
}

const PALETTE = [
  'var(--chart-1)',
  'var(--chart-2)',
  'var(--chart-3)',
  'var(--chart-4)',
  'var(--chart-5)',
];

const chartConfig: ChartConfig = {
  session_count: { label: 'Sessions' },
};

export function CategoryDistributionChart({ data }: CategoryDistributionChartProps) {
  if (data.length === 0) {
    return (
      <div className="flex h-[240px] items-center justify-center text-sm text-muted-foreground">
        No sessions in this range
      </div>
    );
  }
  return (
    <ChartContainer config={chartConfig} className="h-[240px] w-full">
      <PieChart>
        <ChartTooltip content={<ChartTooltipContent indicator="dot" nameKey="category" />} />
        <Pie
          data={data}
          dataKey="session_count"
          nameKey="category"
          innerRadius={60}
          outerRadius={100}
          paddingAngle={2}
        >
          {data.map((_, i) => (
            <Cell key={i} fill={PALETTE[i % PALETTE.length]} />
          ))}
        </Pie>
      </PieChart>
    </ChartContainer>
  );
}
